import React, {Component} from 'react';
import Dropdown from "../../../../controls/Dropdown";
import BackEnd from "../../../../backend/BackEnd";
import AddressSelector from "../../../../controls/AddressSelector";
import {withRouter} from "react-router";
import DateTimePicker from "../../../../controls/DateTimePicker";
import moment from "moment";
import {errorToast} from "../../../../utils/toasts";
import Fieldset from "../../../../utils/components/Fieldset";
import {validate, addressRequired, min, number, required} from "../../../../utils/validation";

class CreateTender extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        typeId: 1,
        companyId: 0,
        orderNumber: '',
        deliveryDate: moment().format(),
        deliveryAddress: {},
        productId: 0,
        count: '',
        price: '',
        formState: {}
    };
    fieldUpdateHandle = (event => this.setState({[event.target.name]: event.target.value}));
    createTenderEndpoint = new BackEnd.TenderCreation.CreateTender(this);
    formMetadata = {
        companyId: [required('Выберите конечного получателя')],
        deliveryDate: [required('Укажите дату и время доставки')],
        deliveryAddress: [addressRequired('Укажите адрес доставки')],
        productId: [required('Выберите артикул из списка')],
        count: [required('Укажите количество'), number(), min(1, 'Количество не может быть меньше 1')],
        price: [required('Укажите ставку клиента'), number(), min(0, 'Ставка клиента не может быть меньше 0')]
    };

    componentDidMount() {
        this.setState({deliveryDate: moment().format()});
    }

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>Новый тендер</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="panel">
                            <div className="panel-body">
                                <form className={`col-md-12 col-lg-12 col-xl-9 ${this.state.isLoading ? 'form-loading' : ''}`}>
                                    <div className="row m-b-3">
                                        <div className="col-md-12">
                                            <label className="m-r-2">Тип тендера</label>
                                            <label className="custom-control custom-radio radio-inline">
                                                <input type="radio" className="custom-control-input"
                                                       name="typeId"
                                                       value="1"
                                                       checked={this.state.typeId === 1}
                                                       onChange={event => this.setState({typeId: parseInt(event.target.value)})}/>
                                                <span className="custom-control-indicator"/>
                                                <strong>На покупку</strong>
                                            </label>
                                            <label className="custom-control custom-radio radio-inline">
                                                <input type="radio" className="custom-control-input"
                                                       name="typeId"
                                                       value="2"
                                                       checked={this.state.typeId === 2}
                                                       onChange={event => this.setState({typeId: parseInt(event.target.value)})}/>
                                                <span className="custom-control-indicator"/>
                                                <strong>На продажу</strong>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <Fieldset formState={this.state.formState} fieldName="companyId">
                                                <label className="control-label required"
                                                       htmlFor="companyId">Конечный получатель</label>
                                                <Dropdown id="companyId" name="companyId"
                                                          placeholder="Выберите клиента"
                                                          dataSource={new BackEnd.TenderCreation.SearchCompanies()}
                                                          onChange={this.fieldUpdateHandle}/>
                                            </Fieldset>
                                        </div>
                                        <div className="col-md-4">
                                            <Fieldset formState={this.state.formState} fieldName="deliveryDate">
                                                <label className="control-label required"
                                                       htmlFor="deliveryDate">Дата доставки</label>
                                                <DateTimePicker className="form-control"
                                                                value={this.state.deliveryDate}
                                                                onChange={deliveryDate => this.setState({deliveryDate})}/>
                                            </Fieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Fieldset formState={this.state.formState} fieldName="deliveryAddress">
                                                <label className="control-label required"
                                                       htmlFor="deliveryAddress">Адрес доставки</label>
                                                <AddressSelector className="form-control"
                                                                 name="deliveryAddress" id="deliveryAddress"
                                                                 placeholder="Любой город или регион"
                                                                 precision="address"
                                                                 value={this.state.deliveryAddress}
                                                                 onChange={deliveryAddress => this.setState({deliveryAddress})}/>
                                            </Fieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <fieldset className="form-group">
                                                <label htmlFor="orderNumber">Номер заказа</label>
                                                <input type="text" className="form-control"
                                                       name="orderNumber" id="orderNumber"
                                                       value={this.state.orderNumber}
                                                       onChange={this.fieldUpdateHandle}/>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Fieldset formState={this.state.formState} fieldName="productId">
                                                <label className="control-label required"
                                                       htmlFor="productId">Наименование поддона</label>
                                                <Dropdown id="productId" name="productId"
                                                          placeholder="Выберите артикул"
                                                          dataSource={new BackEnd.TenderCreation.SearchProducts()}
                                                          onChange={this.fieldUpdateHandle}/>
                                            </Fieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 col-lg-6 col-xl-4">
                                            <Fieldset formState={this.state.formState} fieldName="count">
                                                <label className="control-label required"
                                                       htmlFor="count">Количество поддонов</label>
                                                <div className="input-group">
                                                    <input type="number" className="form-control"
                                                           name="count" id="count"
                                                           value={this.state.count}
                                                           onChange={this.fieldUpdateHandle}/>
                                                    <span className="input-group-addon">шт.</span>
                                                </div>
                                            </Fieldset>
                                        </div>
                                        <div className="col-md-12 col-lg-6 col-xl-4">
                                            <Fieldset formState={this.state.formState} fieldName="price">
                                                <label className="control-label required"
                                                       htmlFor="price">Ставка клиента за поддон</label>
                                                <div className="input-group">
                                                    <input type="number" className="form-control"
                                                           name="price" id="price"
                                                           value={this.state.price}
                                                           onChange={this.fieldUpdateHandle}/>
                                                    <span className="input-group-addon">руб. с НДС</span>
                                                </div>
                                            </Fieldset>
                                        </div>
                                    </div>
                                    <button type="button" className="btn btn-lg btn-primary m-t-3"
                                            onClick={() => this.createTender()}>
                                        Создать тендер
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    async createTender() {
        const {
            typeId, companyId, orderNumber,
            deliveryDate, deliveryAddress,
            productId, count, price
        } = this.state;

        const {isValid, ...formState} = validate(this.state, this.formMetadata);
        if (!isValid)
            return this.setState({formState});

        const result = await this.createTenderEndpoint.call({
            dto: {
                typeId, companyId, orderNumber,
                deliveryDate, deliveryAddress,
                productId, count, price
            }
        });

        if (result.success) {
            this.props.history.push('/tenders/new')
        }
        else if (result.errorMessage) {
            errorToast(result.errorMessage);
        }
    }
}

export default withRouter(CreateTender);


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/CreateTender/CreateTender.js